<template>

    <common-table :table-columns="tableColumns" :url="url" :operate="operate" :form-fields="formFields" :permission="permission" :searchs="searchs" ref="table"></common-table>
</template>

<script>
    import CommonTable from "@/components/CommonTable/CommonTable";
    export default {
        name: "LivePublishPlanRunEvent",
        components: {CommonTable},
        data(){
            return {
                searchs:[
                    {
                        name: 'runId',
                        placeholder: '运行ID',
                        type: 'input'
                    },
                    {
                        name: 'planId',
                        placeholder: '计划ID',
                        type: 'input'
                    },
                    {
                        name: 'accountId',
                        placeholder: '账号ID',
                        type: 'input'
                    },
                    {
                        name: 'accountName',
                        placeholder: '账号名称',
                        type: 'input'
                    },
                    {
                        name: 'status',
                        placeholder: '状态',
                        type: 'select',
                        selectValue: [{key:'success', value:'success'},{key:'failed', value:'failed'},{key:'skipped', value:'skipped'}]
                    }
                ],
                permission:{},
                url: {
                    get: '/livePublish/planRunEvent/listByCondition'
                },
                tableColumns: [{
                    field: 'id',
                    label: 'Id',
                    show: true,
                    width: '75',
                }, {
                    field: 'runId',
                    label: '运行ID',
                    show: true,
                    width: '',
                }, {
                    field: 'planId',
                    label: '计划ID',
                    show: true,
                    width: '',
                }, {
                    field: 'accountId',
                    label: '账号ID',
                    show: true,
                    width: '',
                }, {
                    field: 'accountName',
                    label: '账号名称',
                    show: true,
                    width: '',
                }, {
                    field: 'status',
                    label: '状态',
                    show: true,
                    width: '100',
                }, {
                    field: 'dispatchId',
                    label: '调度ID',
                    show: true,
                    width: '',
                }, {
                    field: 'errorReason',
                    label: '错误原因',
                    show: true,
                    width: '',
                }, {
                    field: 'message',
                    label: '消息',
                    show: true,
                    width: '',
                }],
                operate: [],
                formFields: {
                    addTitle: '',
                    updateTitle: '',
                    model: []
                }
            }
        }
    }
</script>

<style scoped>

</style>
